module.exports = __webpack_public_path__ + "img/red_btn.4e6f6ce4.png";